//@ts-nocheck
import { getH3CellsInView } from './typesAndUtils';
import { getTable } from './tableManager';
import { createGeoArrowScatterplotLayer } from './geoArrowScatterplotLayer';
import { Table} from 'apache-arrow';
import { GeoArrowScatterplotLayer } from '@geoarrow/deck.gl-layers';
import { orderedSicLetters } from './typesAndUtils';

const layerCache: Record<string, GeoArrowScatterplotLayer | null> = {};

let deckInstance: any = null; // Store Deck instance

const gasplIndices = [];

export function setDeckInstance(deck: any) {
  deckInstance = deck;
}

function getScatterPlotLayers(tableRecord)
{
  const _layers: Record<string, GeoArrowScatterplotLayer | null> = {};
  
  // Iterate over records, creating GASPLs
  for (const [key, value] of Object.entries(tableRecord)) {
    _layers[key] = createGeoArrowScatterplotLayer(value, key);
  }
  
  return _layers;
}

function getLayersFromCache(h3Cells, letters)
{
  // Return record of any layers already in cache, and return a list of layers not found in cache, taking account
  // If we are in single table mode, we are only dealing with layers of form e.g. '83194afffffffff-*'
  // and so letters will be ["*"]
  const cacheHits = {}
  const cacheMisses = []

  for(const h3Cell of h3Cells)
  {
    for(const letter of letters)
      {
        const key = `${h3Cell}-${letter}`;
        // Add found layer to cacheHits
        if(key in layerCache)
        {
          cacheHits[key] = layerCache[key];
          continue;
        }
        // Add not found layer to cacheMisses
        cacheMisses.push(key)
      } 
  }
  

  return {"cacheHits":cacheHits,
    "cacheMisses": cacheMisses
  }

}

export function handlePanZoom(viewState)
{
  handleLayerVisibilityChange(storedCheckLetters, viewState);
}

// checkedLetters will not change on pan/zoom, so we can reuse handleLayerVisibilityChange
// for panning/zooming by just storing every layer visibility change and then
// having pan/zoom call this function, I think
let storedCheckLetters = [];

export function handleLayerVisibilityChange(checkedLetters, viewState)
{
  const start = performance.now(); // End timer
  

  // Else this is startup time
  // This ensures we only set layers a single time at startup, and when we
  // actually have the layers ready - the startup sequence generates several
  // calls to this function, for whatever reason
  // And, on later calls, we don't want to regenerate the layers, but instead use
  // the per-layer visibility defined above
  if ("layers" in deckInstance.layerManager && deckInstance.layerManager.layers.length == 0) {
    const viewStateParams = {
      latitude: viewState.latitude,
      longitude: viewState.longitude,
      zoom: viewState.zoom,
      width: window.innerWidth,
      height: window.innerHeight,
      resolution: 3,
    };
    const visibleH3Cells = getH3CellsInView(viewStateParams);
  
    storedCheckLetters = orderedSicLetters;
    const layers = getLayersToShow(visibleH3Cells, checkedLetters);
    if (layers.length > 0) {
      deckInstance.setProps({ layers: layers });
    }
    return;
  }
  
  if (gasplIndices.length == 0) {
    // Mutate gasplIndices in place instead of reassigning
    for (let i = 0; i < deckInstance.layerManager.layers.length; i++) {
      if (deckInstance.layerManager.layers[i].props.id.includes('geoarrow-scatterplot')) {
        gasplIndices.push(i);
      }
    }
  }
  
  storedCheckLetters = checkedLetters;
  
  const viewStateParams = {
    latitude: viewState.latitude,
    longitude: viewState.longitude,
    zoom: viewState.zoom,
    width: window.innerWidth,
    height: window.innerHeight,
    resolution: 3,
  };
  const visibleH3Cells = getH3CellsInView(viewStateParams);
  
  if (deckInstance.layerManager.layers.length > 0) {
    let layerVisibilities = {};
    if (visibleH3Cells?.length != 0) {
      layerVisibilities = getLayerNamesToShow(visibleH3Cells, checkedLetters);
    } else {
      layerVisibilities = getLayerNamesToShow(visibleH3Cells, []);
    }
  
    const deckLayers = deckInstance.layerManager.layers;
    // Single loop to toggle visibility, using original props reassignment
    for (let i = 0; i < gasplIndices.length; i++) {
      const layerIndex = gasplIndices[i];
      const layerId = deckLayers[layerIndex].props.id;
      const isVisible = layerVisibilities["show"].some(name => layerId.includes(name));
      deckLayers[layerIndex].props = { ...deckLayers[layerIndex].props, visible: isVisible };
    }
  }
  
  const end = performance.now();
  console.log(`${(end - start).toFixed(2)}ms`);
  
  
}

// When there is actually some work required on layers
// We will retrieve any we can from the cache, create and add to the cache any we can't retrieve from the cache
// And finally return the whole set of layers
function getLayerNamesToShow(visibleH3Cells, checkedLetters)
{

  let layerNamesToShow = [];
  let layerNamesToHide = [];

  // Show everything
  if(checkedLetters.length == orderedSicLetters.length || (checkedLetters.length == 1 && checkedLetters[0] == '*') )
    {
      layerNamesToHide = [];
      for(const h3Cell of visibleH3Cells)
      {
        for(const letter of orderedSicLetters)
        {
          const layerName = `${h3Cell}-${letter}`;
          layerNamesToShow.push(layerName);
        }
      }
      return {"show": layerNamesToShow, "hide":layerNamesToHide};
    }
  
  // Hide everything
  if(checkedLetters.length == 0)
  {
    layerNamesToShow = [];
    for(const h3Cell of visibleH3Cells)
    {
      for(const letter of orderedSicLetters)
      {
        const layerName = `${h3Cell}-${letter}`;
        layerNamesToHide.push(layerName);
      }
    }
    return {"show": layerNamesToShow, "hide":layerNamesToHide};
  }

  // Show some
  if(checkedLetters.length >= 1 && checkedLetters[0] != "*")
  {
    for(const h3Cell of visibleH3Cells)
    {
      // Iterate over checked letters so that we can set to false those that are not in
      // checkedLetters
      for(const letter of orderedSicLetters)
      {
        const layerName = `${h3Cell}-${letter}`;
        if(checkedLetters.includes(letter))
        {
          layerNamesToShow.push(layerName);
        }
        else
        {
          layerNamesToHide.push(layerName);
        }
      }
    }
    return {"show": layerNamesToShow, "hide":layerNamesToHide};
  }
}

// When there is actually some work required on layers
// We will retrieve any we can from the cache, create and add to the cache any we can't retrieve from the cache
// And finally return the whole set of layers
function getLayersToShow(visibleH3Cells, checkedLetters)
{
  // Show all, so use all letters (* comes from UI for simplicity)
  if(checkedLetters == "*")
  {
    checkedLetters = orderedSicLetters;
  }

  // Get available and missing layers from cache
  const {cacheHits, cacheMisses} = getLayersFromCache(visibleH3Cells, checkedLetters);

  // No misses, return layers immediately
  if(cacheMisses.length == 0)
  {
    return cacheHits;
  }

  // Else we need to make some layers
  const layersRequired: Record<string, Table | null> = {};
  // Make the object required by getScatterPlotLayers
  cacheMisses.forEach(layerName => {
    const table = getTable(layerName);
    if (table) {
      layersRequired[layerName] = table;
    }
  });

  const newLayers = getScatterPlotLayers(layersRequired);
  
  // Merge the pre-existing and newly made tables, and return as an array
  return Object.values({ ...cacheHits, ...newLayers });

}